import {Collapse, Empty, Input, Tabs, Tree} from 'antd'
import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useEffect, useMemo, useState,} from 'react'
import {BsSearch} from 'react-icons/bs'
import {IoAlertCircleSharp} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {compare, NullAsDefault, renderElse, renderIf} from 'views/Shared'
import CodiDocumentContext, {CodiDocumentContentTypes,} from '../../CodiDocumentContext'
import {CodiSubHeader} from './CodiSiderHeading'
import {copyLocationParam} from "../../../../envs/_current/history";
import TooltipApp from "components/TooltipApp";
import dayjs from "dayjs";

const createTreeData = (data = [], {level = 0, parent = []} = {}) =>
    Array.from(data)
        .map((item) => {
            const {
                content,
                attention_flag,
                index_cd,
                index_typecd,
                children_rows = [],
            } = item || {}

            const id = item?.id

            const isLeaf =
                _.isEmpty(children_rows) ||
                index_typecd === CodiDocumentContentTypes.ARTICLE

            const next_rows = Array.from(
                children_rows.filter(
                    (e) =>
                        !!!e.is_html &&
                        !!![
                            CodiDocumentContentTypes.CONTENT,
                            CodiDocumentContentTypes.POINT,
                            CodiDocumentContentTypes.CLAUSE,
                        ].includes(e.index_typecd)
                )
            )

            const withClassNames = ({index_typecd}) => {
                switch (index_typecd) {
                    case CodiDocumentContentTypes.ROOT:
                        return 'uppercase text-color-000 font-bold text-lg'
                    case CodiDocumentContentTypes.PART:
                    case CodiDocumentContentTypes.APPENDIX:
                        return 'text-color-000 font-semibold'
                    case CodiDocumentContentTypes.CHAPTER:
                        return 'text-primary font-semibold capitalize'
                    case CodiDocumentContentTypes.SECTION:
                        return 'text-blue-500 font-medium capitalize'
                    case CodiDocumentContentTypes.ARTICLE:
                        return 'text-color-100'
                    default:
                        return undefined
                }
            }

            const title = (
                <Translate>
                    {(t) => (
                        <div className="gap-1 anchor-offset max-lines-3">
                            {String(index_cd).length > 0 && (
                                <span
                                    className={classNames(
                                        'text-color-000',
                                        level === 0 ? 'font-bold' : 'font-semibold'
                                    )}>
                  {level >= 3 &&
                  ![
                      CodiDocumentContentTypes.ARTICLE,
                      CodiDocumentContentTypes.CONTENT,
                  ].includes(index_typecd)
                      ? [t(index_typecd), index_cd].join(' ')
                      : `${index_cd}: `}
                </span>
                            )}
                            <span
                                className={classNames(
                                    !isLeaf && withClassNames({index_typecd}),
                                    index_typecd === CodiDocumentContentTypes.CONTENT &&
                                    _.isEmpty(index_cd) &&
                                    'italic text-color-300 font-light text-sm leading-tight',
                                    'flex-wrap items-center gap-1'
                                )}>
                {[
                    CodiDocumentContentTypes.ARTICLE,
                    CodiDocumentContentTypes.CLAUSE,
                    CodiDocumentContentTypes.POINT,
                ].includes(index_typecd) &&
                (!!attention_flag ? (
                    <IoAlertCircleSharp
                        size={12}
                        className="text-orange-500"
                    />
                ) : (
                    <span/>
                ))}
                                {content === 'deleted' ? (
                                    t('annulled')
                                ) : (
                                    <TooltipApp title={content}>
                                        <span className="">{content}</span>
                                    </TooltipApp>
                                )}
              </span>
                        </div>
                    )}
                </Translate>
            )

            return _.omitBy(
                {
                    title,
                    isLeaf,
                    key: id,
                    parent: [...parent, id],
                    keywords: [content, index_cd, index_typecd],
                    ..._.pick(item, [
                        'id',
                        'idname',
                        'content',
                        'index_cd',
                        'index_typecd',
                    ]),
                    children:
                        index_typecd === CodiDocumentContentTypes.ARTICLE
                            ? []
                            : createTreeData(next_rows, {
                                level: level + 1,
                                parent: [...parent, id],
                            }),
                },
                _.isUndefined
            )
        })
        .filter(Boolean)

const MobileMenuRenderer = ({
                                routes = [],
                                activeKey,
                                onMenuClick = (key) => {
                                },
                            }) =>
    renderElse(
        _.isEmpty(routes),
        <Translate>
            {(t) => (
                <Collapse
                    accordion={true}
                    onChange={(key) => {
                        onMenuClick(key)
                    }}
                    className="m-1 rounded-md"
                    defaultActiveKey={activeKey}>
                    {Array.from(routes).map(({label, value, component: Component}) => (
                        <Collapse.Panel
                            key={value}
                            header={<span className="font-bold">{t(label)}</span>}>
                            <Component/>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            )}
        </Translate>
    )

const DesktopMenuRenderer = ({
                                 routes = [],
                                 activeKey,
                                 onMenuClick = (key) => {
                                 },
                             }) =>
    renderElse(
        _.isEmpty(routes),
        <Translate>
            {(t) => (
                <Tabs
                    tabBarGutter={8}
                    className="stickyTop"
                    defaultActiveKey={activeKey}
                    tabBarStyle={{ margin: 0 }}
                    onChange={(key) => {
                        onMenuClick(key);
                    }}
                    items={routes.map(({ label, value, component: Component }) => ({
                        key: value,
                        label: <div className="px-2 flex flex-1">{t(label)}</div>,
                        children: <Component />,
                    }))}
                />

            )}
        </Translate>
    )

const getParentKey = (key, tree) => {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.children) {
            if (node.children.some((item) => item.key === key)) {
                parentKey = node.key
            } else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children)
            }
        }
    }
    return parentKey
}

export const OriginalDocument = () => {
    const {item} = useContext(CodiDocumentContext)

    const {document} = item ?? {}

    const document_idname = document?.idname

    const published_date = document?.published_date

    const issued_place = document?.issued_place?.title

    return (
        <div className="flex flex-col gap-2 mb-3">
            <CodiSubHeader title="original document"/>
            <div className="flex flex-col gap-1">
                <Link
                    target="_blank"
                    className="text-primary font-bold no-underline"
                    to={getLinkToDetail(document)}>
                    {_.get(item, 'document.title')}
                </Link>
                <div className="px-1">
                    <div className="flex gap-1 text-xs italic ml-1 mb-2">
                        {renderIf(
                            issued_place,
                            <span className="text-color-000 font-medium">{issued_place}</span>
                        )}
                        {renderIf(
                            published_date,
                            <span className="text-color-300">
                {renderIf(issued_place, ' - ')}
                                {dayjs(published_date).format('DD/MM/YYYY')}
              </span>
                        )}
                    </div>
                    <span className="ml-1 text-color-400 font-light text-xs italic">
            {document?.description}
          </span>
                </div>
            </div>
        </div>
    )
}

export const CodiDocumentTree = ({
                                     item,
                                     style,
                                     className,
                                     header = null,
                                     onItemClick = NullAsDefault,
                                     defaultExpandedKeys,
                                 }) => {
    const t = useTranslate()

    const history = useHistory()

    const [keyword, setKeyword] = useState()

    const [expandedKeys, setExpandedKeys] = useState([])

    const [autoExpandParent, setAutoExpandParent] = useState(true)

    const {rows = []} = item ?? {}

    const title = _.get(item, 'overview.title')

    useEffect(() => {
        if (!_.isEmpty(defaultExpandedKeys ?? undefined)) {
            setExpandedKeys(Array.from(defaultExpandedKeys))
        }
    }, [defaultExpandedKeys])

    const hasKeyword = !_.isEmpty(String(keyword ?? '').trim())

    const root = _.find(
        rows,
        ({index_typecd}) => index_typecd === CodiDocumentContentTypes.ROOT
    )

    const treeData = useMemo(() => {
        const data = Array.from(_.get(root, 'children_rows', [])).filter(
            ({index_typecd}) => index_typecd !== CodiDocumentContentTypes.CONTENT
        )
        return createTreeData(data)
    }, [rows, root, expandedKeys])

    const getExpandedKeys = (rows = [], index = 0) => {
        let result = []
        Array.from(_.filter(rows)).forEach(
            ({index_typecd, children_rows, ...rest}) => {
                const id = rest.id
                let _children = Array.from(children_rows || [])
                if (
                    [
                        CodiDocumentContentTypes.ROOT,
                        CodiDocumentContentTypes.PART,
                        CodiDocumentContentTypes.APPENDIX,
                        CodiDocumentContentTypes.CHAPTER,
                        CodiDocumentContentTypes.SECTION,
                    ].includes(index_typecd) &&
                    !_.isEmpty(_children)
                ) {
                    result.push(id)
                    if (index === 0) {
                        _children = [
                            _.first(
                                Array.from(_children).filter(
                                    ({children_rows}) => !_.isEmpty(children_rows)
                                )
                            ),
                        ]
                    }
                    const next_keys = getExpandedKeys(_children, index + 1)
                    result = [...result, ...next_keys]
                }
            }
        )
        return result
    }

    const filterData = useCallback(
        (array, keysToExpand = []) =>
            Array.from(array || [])
                .map(({children, ...rest}) => {
                    const _next_children = filterData(children, keysToExpand)
                    return {
                        ...rest,
                        children: _next_children,
                        isLeaf: _.isEmpty(_next_children),
                    }
                })
                .filter(({key, children, keywords = []}) => {
                    const matched = _.some(keywords, (value) => compare(value, keyword))
                    if (matched) {
                        keysToExpand.push(key)
                    }
                    return matched || filterData(children, keysToExpand)?.length > 0
                }),
        [keyword]
    )

    const filteredTreeData = (data) => {
        let output = []
        const filteredData = hasKeyword ? filterData(data, output) : data
        const keysToExpand = _.uniqBy(output)
        if (hasKeyword) {
            setExpandedKeys(keysToExpand)
            setAutoExpandParent(true)
        }
        return [filteredData, keysToExpand]
    }

    const [tree, setTree] = useState([])

    const [searchResult, setSearchResult] = useState([])

    useEffect(() => {
        if (hasKeyword) {
            const [filteredData, result] = filteredTreeData(treeData)
            setTree(filteredData)
            setSearchResult(result)
        } else {
            setTree(treeData)
        }
    }, [keyword])

    const handleSelect = (keys, info) => {
        const {key, children, expanded} = info?.node ?? {}
        if (!expanded && children?.length) {
            setAutoExpandParent(true)
            setExpandedKeys([...expandedKeys, key])
        } else {
            onItemClick(info, {
                item: info?.node,
                animate: () => {
                    if (key) {
                        history.push({
                            ...copyLocationParam(window.location ?? {}),
                            hash: `#${key}`,
                        })
                        const element = document.getElementById(key)
                        if (element) {
                            element.scrollIntoView({behavior: 'smooth'})
                        }
                    }
                },
            })
        }
    }

    const handleSearch = _.debounce((keyword) => {
        if (keyword) {
            setKeyword(keyword)
        } else {
            setKeyword('')
            // setExpandedKeys([])
        }
    }, 300)

    // useEffect(() => {
    //   if (!_.isEmpty(rows) && root) {
    //     const default_expanded_keys = Boolean(!_.isEmpty(rows) && root)
    //       ? getExpandedKeys([root])
    //       : []
    //     setExpandedKeys(default_expanded_keys)
    //   }
    // }, [rows, root])

    return (
        <div
            style={style}
            className={classNames('flex flex-col', className)}>
            {header}
            <div className="flex flex-col space-y-3">
                {/*<OriginalDocument />*/}
                <Input
                    allowClear={true}
                    placeholder={t('enter your keyword')}
                    prefix={<BsSearch className="text-color-400 mr-2"/>}
                    className="rounded-md"
                    showCount={
                        hasKeyword
                            ? {
                                formatter: () => (
                                    <span className="text-sm text-color-400">
                      {Array.from(searchResult).length}
                    </span>
                                ),
                            }
                            : undefined
                    }
                    onChange={(event) => {
                        const keyword = event.target.value
                        handleSearch(keyword)
                    }}
                />
                <div className="text-base font-bold text-color-000 leading-tight">
                    {title}
                </div>
                <Tree
                    showLine={true}
                    treeData={tree}
                    onSelect={handleSelect}
                    expandedKeys={expandedKeys}
                    onExpand={(keys, info) => {
                        setAutoExpandParent(false)
                        const current_key = info.node.key
                        if (info.expanded) {
                            setExpandedKeys(_.uniqBy([...keys, current_key]))
                        } else {
                            setExpandedKeys(keys.filter((key) => key !== current_key))
                        }
                    }}
                    autoExpandParent={autoExpandParent}
                    filterTreeNode={({keywords = []}) =>
                        hasKeyword && _.some(keywords, (value) => compare(value, keyword))
                    }
                />
                {_.isEmpty(tree) && (
                    <Empty description={<span>{t('no item found')}</span>}/>
                )}
            </div>
        </div>
    )
}

const CodiDocumentMenu = ({
                              activeKey,
                              routes = [],
                              handleMenuClick = NullAsDefault,
                          }) => {
    const {isSm} = useContext(LayoutContext)

    let Renderer = NullAsDefault

    if (!!isSm) {
        Renderer = MobileMenuRenderer
    } else {
        Renderer = DesktopMenuRenderer
    }

    return (
        <Renderer
            {...{
                routes,
                activeKey,
                onMenuClick: handleMenuClick,
            }}
        />
    )
}

export default CodiDocumentMenu
